<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <PublicLandingHeader
      :title="appSettingsStore.applicationTitle"
      subtitle="Hawaii State Environmental Health Administration"
      light
    />

    <PublicLandingContainer class="grid justify-stretch md:justify-center 2xl:max-w-screen-2xl">
      <PublicLandingBackdrop light class="grid grid-cols-1 gap-10">
        <PublicLandingOnlineServices
          class=""
          title="Internal Services"
          body="The Mail app provides online employee access to internal routing, incoming mail, outgoing mail, and workflow tracking for the Clean Air Branch, Clean Water Branch, Safe Drinking Water Branch, Solid and Hazardous Waste Branch, Surface Water Protection Branch, and Wastewater Branch."
          hide-register
        ></PublicLandingOnlineServices>

        <PublicLandingCard>
          <PublicLandingCardSection label="Internal Routing">
            <PublicLandingParagraph
              >Find, view, and manage Environmental Management Division internal routing.</PublicLandingParagraph
            >
            <PublicLandingList>
              <PublicLandingListItem label="Track open and closed internal routing items by branch" />
              <PublicLandingListItem label="Manage internal routing item file attachments and notes" />
              <PublicLandingListItem label="Monitor internal routing workflow tasks and status" />
            </PublicLandingList>
          </PublicLandingCardSection>

          <PublicLandingCardSection label="Inbox">
            <PublicLandingParagraph
              >Find, view, and manage Environmental Management Division incoming mail.</PublicLandingParagraph
            >
            <PublicLandingList>
              <PublicLandingListItem label="Track open and closed inbox items by branch" />
              <PublicLandingListItem label="Manage inbox item file attachments and notes" />
              <PublicLandingListItem label="Monitor workflow tasks and status for incoming mail" />
            </PublicLandingList>
          </PublicLandingCardSection>

          <PublicLandingCardSection label="Outbox">
            <PublicLandingParagraph
              >Find, view, and manage Environmental Management Division outgoing mail.</PublicLandingParagraph
            >
            <PublicLandingList>
              <PublicLandingListItem label="Track open and closed outbox items by branch" />
              <PublicLandingListItem label="Manage outbox item file attachments and notes" />
              <PublicLandingListItem label="Monitor workflow tasks and status for outgoing mail" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
      </PublicLandingBackdrop>
    </PublicLandingContainer>

    <MdrnFooter light black-and-white />
  </div>
</template>

<script lang="ts">
import { InitialBadge } from "@modernary/mui/components/badge";
import { BaseButton } from "@modernary/mui/components/button";
import { MdrnFooter, NoneFoundFlag, useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { LoginButton, LogoutButton, RegisterButton } from "@modernary/mui/utils/authentication/buttons";
import { computed, defineComponent } from "vue";

import {
  PublicLandingBackdrop,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingContainer,
  PublicLandingHeader,
  PublicLandingLinkCard,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingOnlineServices,
  PublicLandingParagraph,
} from "@modernary/mui/components/publicLanding";
import { routeNames } from "@/routes";

// Home content for unauth'd users
export default defineComponent({
  name: "HomePublic",
  setup() {
    const appSettingsStore = useAppSettingsStore();

    return { BaseButton, appSettingsStore, routeNames };
  },
  components: {
    BaseButton,
    InitialBadge,
    LoginButton,
    RegisterButton,
    MdrnFooter,
    NoneFoundFlag,
    LogoutButton,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingParagraph,
    PublicLandingLinkCard,
    PublicLandingOnlineServices,
    PublicLandingHeader,
    PublicLandingContainer,
    PublicLandingBackdrop,
  },
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #140602; /* average color from the sky of the bg */
  background-image: url("/images/backgrounds/hi.jpg");
  background-size: cover;
  background-position: center 0;
  background-repeat: no-repeat;
}
</style>
